import { render, staticRenderFns } from "./ConversationDetail.vue?vue&type=template&id=687bdf3b&scoped=true&"
import script from "./ConversationDetail.vue?vue&type=script&lang=js&"
export * from "./ConversationDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConversationDetail.vue?vue&type=style&index=0&id=687bdf3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687bdf3b",
  null
  
)

export default component.exports